/**
 * Mempool.space API URL for mainnet
 */
export const MEMPOOL_API_URL = 'https://mempool.space/api';

/**
 * Number of satoshis per Bitcoin
 */
export const SATOSHIS_PER_BTC = 100_000_000;

/**
 * Bitcoin's dust limit in satoshis
 * Outputs below this value are considered "dust" and will be rejected by nodes
 */
export const DUST_LIMIT = 546;

/**
 * Accurate vSize constants for Native SegWit (P2WPKH) transactions
 * Used for precise fee estimation
 */
export const VSIZE_OVERHEAD = 10.5;

export const VSIZE_INPUT_P2WPKH = 68;

export const VSIZE_OUTPUT_P2WPKH = 31;

/**
 * Minimum relay fee in satoshis
 * Added to fee estimate to ensure transaction propagation
 */
export const MIN_RELAY_FEE = 111;

/**
 * Conservative default fee estimate in satoshis
 * Used as fallback when fee estimation fails
 */
export const DEFAULT_FEE_ESTIMATE = 1000;

/**
 * RBF (Replace-By-Fee) sequence number
 * 0xfffffffd = 4294967293 (enables RBF, not final)
 */
export const RBF_SEQUENCE = 0xfffffffd;
